import type { ActionCreator } from 'redux';
import { connect } from 'react-redux';

import displayValues from '../../../resources/displayValues.json';
import { fetchResults } from '../../../state/resultActions';
import { actions } from '../../../state/filterActions';

import type { OverrideValues, PaleState } from '../../../interfaces';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from './CheckboxFilter';

export const mapStateToProps = (state: PaleState): CheckboxStateProps => ({
    id: 'mealFilter',
    label: 'Måltider',
    facetList: state.results.facets.meals,
    displayValues: displayValues.amenities.meals,
    checkboxValues: state.filters.meals,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterCheckboxMeal,
    fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
